import React, { useMemo, useState } from "react";
import Select from "react-select";
import { X } from "lucide-react";
import { selectStyles } from "../../helpers";

const multiStyles = {
  ...selectStyles,
  menuPortal: (base) => ({ ...base, zIndex: 12000 }),
  control: (base, state) => ({
    ...(selectStyles.control ? selectStyles.control(base, state) : base),
    minHeight: 32,
    height: "auto",
  }),
  valueContainer: (base) => ({
    ...base,
    flexWrap: "wrap",
    paddingTop: 2,
    paddingBottom: 2,
  }),
  multiValue: (base) => ({
    ...base,
    background: "#e6f7f1",
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: "#0aa375",
    fontSize: 12,
  }),
};

const DoctorUsageModal = ({ companyName, companyId, rows, onClose, onDoctorClick }) => {
  const [selectedDoctors, setSelectedDoctors] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);

  const doctorOptions = useMemo(() => {
    const map = new Map();
    rows.forEach((d) => {
      const id = String(d.doctorId || "");
      if (!id || map.has(id)) return;
      map.set(id, { value: id, label: `${d.doctorName || ""} (${id})` });
    });
    return [...map.values()].sort((a, b) => a.label.localeCompare(b.label, undefined, { numeric: true }));
  }, [rows]);

  const locationOptions = useMemo(() => {
    const map = new Map();
    rows.forEach((d) => {
      const id = String(d.locationId || "");
      if (!id || map.has(id)) return;
      map.set(id, { value: id, label: `${d.locationName || ""} (${id})` });
    });
    return [...map.values()].sort((a, b) => a.label.localeCompare(b.label, undefined, { numeric: true }));
  }, [rows]);

  const visible = useMemo(() => {
    const docIds = new Set(selectedDoctors.map((s) => String(s.value)));
    const locIds = new Set(selectedLocations.map((s) => String(s.value)));
    return rows.filter((d) => {
      const okDoc = !docIds.size || docIds.has(String(d.doctorId));
      const okLoc = !locIds.size || locIds.has(String(d.locationId));
      return okDoc && okLoc;
    });
  }, [rows, selectedDoctors, selectedLocations]);

  return (
    <div className="mntu-overlay mntu-overlay-top" onClick={onClose}>
      <div className="mntu-modal" onClick={(e) => e.stopPropagation()}>
        <div className="mntu-modal-header">
          <h3>
            {companyName} ({companyId}) — Doctors
          </h3>
          <button type="button" className="mntu-close" onClick={onClose}>
            <X size={18} />
          </button>
        </div>
        <div className="mntu-modal-filter mntu-modal-filter-2">
          <Select
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            options={doctorOptions}
            value={selectedDoctors}
            onChange={(v) => setSelectedDoctors(v || [])}
            styles={multiStyles}
            menuPortalTarget={document.body}
            menuPosition="fixed"
            placeholder="Filter doctor name / id"
            isClearable
          />
          <Select
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            options={locationOptions}
            value={selectedLocations}
            onChange={(v) => setSelectedLocations(v || [])}
            styles={multiStyles}
            menuPortalTarget={document.body}
            menuPosition="fixed"
            placeholder="Filter location name / id"
            isClearable
          />
        </div>
        <div className="mntu-modal-body">
          <table className="mntu-table">
            <thead>
              <tr>
                <th>Doctor Name</th>
                <th>Doctor Id</th>
                <th>Location Name</th>
                <th>Location Id</th>
                <th>Visit Count</th>
              </tr>
            </thead>
            <tbody>
              {visible.length === 0 ? (
                <tr>
                  <td colSpan={5} className="mntu-empty">No doctors</td>
                </tr>
              ) : (
                visible.map((d) => (
                  <tr key={`${d.doctorId}-${d.locationId}`}>
                    <td>
                      <button type="button" className="mntu-link" onClick={() => onDoctorClick(d)}>
                        {d.doctorName}
                      </button>
                    </td>
                    <td>{d.doctorId}</td>
                    <td>{d.locationName}</td>
                    <td>{d.locationId}</td>
                    <td>
                      <button type="button" className="mntu-link" onClick={() => onDoctorClick(d)}>
                        {d.noteCount}
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default DoctorUsageModal;